import React from 'react';
import OrderFollowupPage from './OrderFollowupPage';

const PickupOrderFollowup = () => (
  <OrderFollowupPage title="Pickup Order Followup" endpoint="GetOrderInPFollowupList" />
);

export default PickupOrderFollowup;
